import React, { useState, useEffect } from 'react';
import './Chat.scss'
require('dotenv').config();

export const HealthCheck = () => {
  const [health, setHealth] = useState();
  useEffect(() => {
    fetch(window.univcbUiConfig.serviceUrl + '/health').then(res => res.json()).then(data => {
      setHealth(data)
      return data;

    });
  }, [])
  return <>{JSON.stringify(health)}</>
}
